import { render, staticRenderFns } from "./AgriculturalWork.vue?vue&type=template&id=02ecf1b4&scoped=true"
import script from "./AgriculturalWork.vue?vue&type=script&lang=js"
export * from "./AgriculturalWork.vue?vue&type=script&lang=js"
import style0 from "./AgriculturalWork.vue?vue&type=style&index=0&id=02ecf1b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ecf1b4",
  null
  
)

export default component.exports